import { Component, OnInit, Inject  } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mod-error',
  templateUrl: './mod-error.component.html',
  styleUrls: ['./mod-error.component.css']
})
export class ModErrorComponent implements OnInit {

 
  constructor() {
    
   }

  ngOnInit() {
    
  }
}
